module.exports = __webpack_public_path__ + "img/icon-mail-blue.46e98dda.svg";